// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__2mEFj","sideMenu":"MainLayout_sideMenu__3nGlJ","content":"MainLayout_content__PqsTE"};